/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteEstatePhoto (id: number) {
  return rest.delete(`/api/estate-photos/${id}`)
}

export function findManyEstatePhotos (params?: Record<string, any>): Promise<HalDocument<{
  photos: EstatePhoto[]
}>> {
  return rest.get(`/api/estate-photos?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function patchEstatePhoto (id: number, photo: Partial<EstatePhoto>) {
  return rest.patch(`/api/estate-photos/${id}`, {
    body: JSON.stringify(photo),
    headers: { 'content-type': 'application/json' }
  })
    .then((resp) => resp.json())
}

export function postEstatePhoto (file: File, estateId: number) {
  const fd = new FormData()
  fd.append('estateId', String(estateId))
  fd.append('photo', file)
  return rest.post('/api/estate-photos', { body: fd })
    .then((resp) => resp.json())
}

export function postTempEstatePhoto (file: File, tmpRef: string) {
  const fd = new FormData()
  fd.append('photo', file)
  fd.append('tmpRef', tmpRef)
  return rest.post('/api/estate-photos', { body: fd })
    .then((resp) => resp.json())
}
